export default __webpack_public_path__ + "static/media/circle-info.10be67c5.svg";